import { Component, OnInit, ViewChild, OnDestroy } from "@angular/core";
import { MatTableDataSource } from "@angular/material/table";
import { MatPaginator } from "@angular/material/paginator";
import { ToastrService } from "ngx-toastr";
import { FieldDataService } from "src/app/services/fieldData/field-data.service";
import { GatewayRaizInterface, gatewayRaiz } from "./querys/querys";
import { elemPingInterface } from "./models/models";
import * as _ from "lodash";

@Component({
  selector: "app-estructura-campo",
  templateUrl: "./estructuraCampo.component.html",
  styleUrls: ["./estructuraCampo.component.scss"],
})
export class EstructuraCampoComponent implements OnInit, OnDestroy {
  public querySubscription: any;
  gatewayInterface: any;
  sub: any;
  arreglo: any;

  // Para la tabla de gateways raiz
  displayedColumns: string[] = ["gateway", "last", "alarmedSources", "sources"];
  dataSource: MatTableDataSource<any>;
  paginatorRaiz: MatPaginator;

  @ViewChild("TableGatewayRaizPaginator", { static: false  }) set matPaginatorRaiz(mp: MatPaginator) {
    this.paginatorRaiz = mp;
    if (this.dataSource)
        this.dataSource.paginator = this.paginatorRaiz;
}
  paginator: MatPaginator;
  gatewayRaizDown: number;


  // Para la tabla de concentradores
  displayedColumnsConcen: string[] = ["nombre", "host", "lastFecha", "alive"];
  dataSourceConcen: MatTableDataSource<any>;
  paginatorConcen: MatPaginator;
  @ViewChild("TableConcenPaginator", { static: false  }) set matPaginator(mp: MatPaginator) {
    this.paginatorConcen = mp;
    if (this.dataSourceConcen)
        this.dataSourceConcen.paginator = this.paginatorConcen;
}

  concentradoresDown: number;

  // Config para los umbrales que vamos a establecer:
  limiteAlerta: any; // Para establecer el límite de la alerta de tiempo
  timeStamp: any = new Date().getTime() * 1000000; // Epoch actual en UTC a nanosegundos
  time: number; // Para asignar el momento actual menos la diferencia del json de config

  dataGatewaysRaiz: any;
  buttonName: string;

  constructor(
    private toastrservice: ToastrService,
    private dataService: FieldDataService
  ) {}

  ngOnInit() {
    // Obtenemos los gateway raiz:
    this.time = this.timeStamp - this.limiteAlerta;
    this.getData();
    this.getConcentradores();
  }

  async getData() {
    // Traemos los datos del limite para la alerta (1h de momento);
    this.dataSource = new MatTableDataSource();
    this.dataService.getConfigFieldData().subscribe((data) => {
      this.limiteAlerta = data.limiteAlarma;
      this.time = this.timeStamp - this.limiteAlerta;
    });
    this.arreglo = [];
    this.gatewayRaizDown = 0;
    this.dataService.getGatewaysRaiz().subscribe((data) => {
      this.dataGatewaysRaiz = data.filter((elem) => elem.sourcesTotal > 0);
      for (let i = 0; i < this.dataGatewaysRaiz.length; i++) {
        this.arreglo[i] = {
          indice: i,
          data: this.dataGatewaysRaiz[i],
        };
        this.dataService
          .getsourceRezagados(this.dataGatewaysRaiz[i].uuid, this.time)
          .subscribe((data) => {
            this.arreglo[i].sourcesRezagados = data;
          });
        this.dataService
          .getNodeAlarms(this.dataGatewaysRaiz[i].uuid)
          .subscribe((data) => {
            this.arreglo[i].alarmadosCount = data.filter(
              (elem) => elem.lastEntrada
            ).length;
            if (data.filter((elem) => elem.lastEntrada).length > 0)
              this.gatewayRaizDown++;
          });
      }
      this.dataSource.data = this.arreglo;
      this.dataSource.paginator = this.paginator;
    });
  }

  // Para obtener el listado de elementos que tienen asignado una IP y responden a ping:
  getConcentradores() {
    this.dataSourceConcen = new MatTableDataSource();
    // Para extraer información de los concrentradores:
    this.dataService.getelemPing().subscribe((data) => {
      data = data.findLmPings;
      this.dataSourceConcen.data = data;
      this.dataSourceConcen.filterPredicate = (data, filter: string) => {
        const accumulator = (currentTerm, key) => {
          return this.nestedFilterCheck(currentTerm, data, key);
        };
        const dataStr = Object.keys(data).reduce(accumulator, "").toLowerCase();
        // Transform the filter by converting it to lowercase and removing whitespace.
        const transformedFilter = filter.trim().toLowerCase();
        return dataStr.indexOf(transformedFilter) !== -1;
      };
      this.dataSourceConcen.paginator = this.paginatorConcen;
      this.concentradoresDown = this.dataSourceConcen.data.filter(
        (r) => r.alive.lastEntrada.lastValor == "false"
      ).length;
    });
  }

  // función para alertar de que el uuid ha sido copiado al portapeles
  //TODO: copiado(event: Event) {
  copiado(event) {
    if (event) {
      this.toastrservice.info("", "Elemento copiado al portapapeles", {
        closeButton: true,
        timeOut: 2000,
      });
    }
  }

  // Funcion pra filtrar la tabla de los gateways
  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  applyFilterConcen(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSourceConcen.filter = filterValue.trim().toLowerCase();
  }

  nestedFilterCheck(search, data, key) {
    if (typeof data[key] === "object") {
      for (const k in data[key]) {
        if (data[key][k] !== null) {
          search = this.nestedFilterCheck(search, data[key], k);
        }
      }
    } else {
      search += data[key];
    }
    return search;
  }

  filterTable(filterMode, dataSource, parameter, operation, value, event) {
    switch (filterMode) {
      case "filter":
        this.buttonName = "Mostrar original";
        switch (dataSource) {
          case "dataSource":
            eval(
              "this." +
                dataSource +
                ".data = this." +
                dataSource +
                ".data.filter(df => df[parameter]" +
                operation +
                value +
                ")"
            );
            break;
          case "dataSourceConcen":
            eval(
              "this." +
                dataSource +
                ".data = this." +
                dataSource +
                ".data.filter(df=>df." +
                parameter +
                ' == "false")'
            );
            break;
        }
        break;
      case "showFullTable":
        this.buttonName = "Filtrar tabla";
        switch (dataSource) {
          case "dataSource":
            this.getData();
            break;
          case "dataSourceConcen":
            this.getConcentradores();
            break;
        }
        break;
    }
    // logic here to filter table showing only rows that have a weight > 10
  }

  ngOnDestroy() {
    // Nos desuscribimos del stream para evitar problemas de memoria
    // this.sub.unsubscribe();
  }
}
